import { useLoading } from '@genial/components';
import { ErrorListResponse, instanceOfErrorListResponse } from '@genial/services';
import { useNavigation } from '@react-navigation/native';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { useSendingChannels } from '../../../hooks/useSendingChannels';
import { useToastCreator } from '../../../hooks/useToastCreator';
import {
  BatchTicketResumeDetailTypeParam,
  SignedInNavigationScreenNavigationProp,
} from '../../../routes/types';
import {
  basketAdvisorOrderIdState,
  basketCustomerOrderResumeState,
} from '../../../store/batchTicket/atom';
import { sessionState } from '../../../store/session/atom';
import { errorMessageBatchTicketRequestItem } from '../../BatchTicketRequests/utils';
import { RequiredAttention } from '../components/Resume/components/RequiredAttention';
import { TotalSummary } from '../components/Resume/components/TotalSummary';
import { patchBasketAdvisorByAccepted } from '../services';

import { useStep } from './useStep';

export const useBatchTicketResume = () => {
  const { cancelOrderIsDisabled, handleCancelOrder } = useStep();
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const basketAdvisorOrderId = useRecoilValue(basketAdvisorOrderIdState);
  const { sendingChannelsOptions, onChannelSelectChange, sendingChannelsSelected } =
    useSendingChannels();
  const { userProfile } = useRecoilValue(sessionState);
  const isManager = !!(userProfile?.isGestor && userProfile?.idTipoParceiro !== 4);

  const basketCustomerOrderResume = useRecoilValue(basketCustomerOrderResumeState);

  const { showToast, showToastFromError } = useToastCreator('toast-finish-basket-service');
  const { hide, show } = useLoading();

  const tabs = [
    {
      key: 'totalSummary' as BatchTicketResumeDetailTypeParam,
      label: 'Resumo total',
      component: <TotalSummary />,
    },
    {
      key: 'requiredAttention' as BatchTicketResumeDetailTypeParam,
      label: 'Requer atenção',
      component: <RequiredAttention />,
      count: basketCustomerOrderResume.data.errors.length,
    },
  ];

  const [selectedTab, setSelectedTab] = useState<BatchTicketResumeDetailTypeParam>(tabs[0].key);

  const selectedTabIsSummary = selectedTab === tabs[0].key;

  const cancelButtonIsDisabled = cancelOrderIsDisabled;
  const actionButtonIsDisabled =
    basketCustomerOrderResume.data.valid.length < 1 || sendingChannelsSelected.length === 0;

  const actionButtonTitle = 'Enviar';

  const handleAction = async () => {
    try {
      show({
        title: 'Aguarde enquanto estamos enviando a boleta.',
        description: 'Este processo pode levar alguns segundos, não saia desta pagina.',
      });

      const response = await patchBasketAdvisorByAccepted(
        basketAdvisorOrderId!,
        sendingChannelsSelected
      );

      navigate('BatchTicketSent', { basketAdvisorOrder: response });
    } catch (error) {
      if (instanceOfErrorListResponse(error as object)) {
        (error as ErrorListResponse).errors?.forEach((errorItem) => showToastFromError(errorItem));
        return;
      }

      showToast(...errorMessageBatchTicketRequestItem);
    } finally {
      hide();
    }
  };
  const onTabPress = (value: BatchTicketResumeDetailTypeParam) => setSelectedTab(value);

  return {
    handleAction,
    cancelButtonIsDisabled,
    handleCancel: handleCancelOrder,
    onTabPress,
    actionButtonIsDisabled,
    actionButtonTitle,
    selectedTab,
    tabs,
    selectedTabIsSummary,
    sendingChannelsOptions,
    onChannelSelectChange,
    sendingChannelsSelected,
    isManager,
  };
};
